const CHAT_COMMAND = {
  // AI搜索
  1: {
    command: "search",
    status_1: "正在联网搜索...",
  },
  // 帮我写作
  2: {
    command: "write",
    status_1: "正在写作...",
  },
  // AI画图
  3: {
    command: "draw",
    status_1: "正在绘图...",
  },
  // 阅读总结
  4: {
    command: "summary",
    status_1: "正在阅读...",
  },
  // 在线翻译
  5: {
    command: "translate",
    status_1: "正在翻译...",
  },
  // 网页摘要
  6: {
    command: "snippets",
    status_1: "正在总结摘要...",
  },
  // 学术搜索
  7: {
    command: "scholarSearch",
    status_1: "正在进行学术搜索...",
  },
  // 图片分析
  8: {
    command: "QA",
    status_1: "正在解析...",
  },
  // ppt
  10: {
    command: "ppt",
    status_1: "正在解析...",
  },
};

export { CHAT_COMMAND };
